<template>
  <div id="pdfvuer">
    <div id="buttons">
        <el-button-group v-if="numPages > 1">
            <el-button type="info" icon="el-icon-arrow-left" @click="page > 1 ? page-- : 1"></el-button>
            <el-button type="info">{{page}} / {{ numPages ? numPages : '∞' }}</el-button>
            <el-button type="info" icon="el-icon-arrow-right" @click="page < numPages ? page++ : 1"></el-button>
        </el-button-group>
    </div>

    <pdf v-if="pdfdata" :src="pdfdata" :page="page" :key="dynamicKey">
      <template slot="loading">
        loading syllabus content here...
      </template>
    </pdf>

  </div>
</template>

<script>
import pdfvuer from 'pdfvuer'
import { ButtonGroup, Button } from "element-ui";

export default {
  components: {
    pdf: pdfvuer,
    [Button.name]: Button,
    [ButtonGroup.name]: ButtonGroup
  },
  props: {
      src: String
  },
  watch:{   
    'src':{
        handler: function(val){
            this.getPdf(val)
        },
        immediate:true
    },
},
  data () {
    return {
        pdfdata: null,
        dynamicKey: 0,
        page: 1,
        numPages: 0,
    }
  },
  methods: {
    getPdf (file) {
        var self = this;
        self.pdfdata = pdfvuer.createLoadingTask(file);
        self.pdfdata.then(pdf => {
            self.numPages = pdf.numPages;
            self.dynamicKey = Math.random(10000);
            setTimeout(() => {
                self.dynamicKey = Math.random(10000);
            }, 100);
        });
    }
  }
}
</script>

<style lang="scss" scoped>
    #buttons{
        text-align: center;
        margin: 2rem 0px;
    }
</style>